import { ReactElement } from "react";
import { SearchResultData } from "../../app/slices/SearchResultsSlice";
import { InteractionFactoryEntity } from "../../features/interaction_factory/InteractionFactory";
import WaitForClickNodePreview from "../../features/sequence/node_previews/WaitForClickNodePreview";
import { GetNewGuid } from "../../helpers/GuidHelper";
import { Actor } from "../Actor";
import Take from "../Take";
import Interaction, { InteractionType } from "./Interaction";
import {
  compactSearchableStrings,
  SearchLookupContext,
} from "./SearchableInteractionValues";

export interface IWaitForClick extends Interaction {
  propGuid: string;
  tag: string;
  indicate: boolean;
  indicateDelay: number;
}

export const waitForClickInteraction = (): InteractionFactoryEntity => {
  const view: ReactElement = <></>;

  const create = (getKeys: (amount: number) => string[]): IWaitForClick => {
    return {
      id: GetNewGuid(),
      name: "Wait For Click",
      type: InteractionType.WaitForClick,
      propGuid: "",
      tag: "",
      indicate: false,
      indicateDelay: 0,
      properties: [],
    };
  };

  const migrate = (
    from: number,
    to: number,
    interaction: Interaction,
  ): IWaitForClick => {
    return interaction as IWaitForClick;
  };

  const copy = (
    interaction: Interaction,
    getKeys: (amount: number) => string[],
    replaceKey: (from: string, to: string) => void,
    getAnswerArray: (originalAnswers: any[], newKeys: string[]) => any[],
  ): IWaitForClick => {
    const original = interaction as IWaitForClick;

    return {
      ...original,
      id: GetNewGuid(),
      properties: original.properties?.map((property) => ({ ...property })) ?? [],
    };
  };

  const validate = (
    interaction: Interaction,
    getValue: (key: string) => string,
    currentTake: Take,
    actorPresets: Actor[],
  ): string[] => {
    const converted = interaction as IWaitForClick;
    const warnings: string[] = [];

    return warnings;
  };

  const validateErrors = (
    interaction: Interaction,
    parentTake: Take,
    currentTake: Take,
    actorPresets: Actor[],
    allPropPresets: any[],
    localizedStringRecords: any,
  ): string[] => {
    const converted = interaction as IWaitForClick;
    const errors: string[] = [];

    if (!converted.propGuid || converted.propGuid === "") {
      errors.push("No prop selected.");
    }

    return errors;
  };

  const filter = (
    interaction: Interaction,
    takeName: string,
    getMatchingResults: (
      searchableStrings: string[],
      takeName: string,
      interaction: Interaction,
      filterType: string,
    ) => SearchResultData[],
    getValue: (key: string) => string,
    searchLookupContext?: SearchLookupContext,
  ): SearchResultData[] => {
    const converted = interaction as IWaitForClick;
    const searchableStrings = compactSearchableStrings(
      converted.name,
      searchLookupContext?.getPropSearchTerms(converted.propGuid) ??
        converted.propGuid,
      converted.tag,
    );

    return getMatchingResults(
      searchableStrings,
      takeName,
      interaction,
      filterType,
    );
  };

  const filterType: string = "Wait For Click";

  return {
    View: view,
    NodeView: (nodeId: string, interaction: Interaction) => (
      <WaitForClickNodePreview nodeId={nodeId} interaction={interaction} />
    ),
    FilterType: filterType,
    Create: create,
    Migrate: migrate,
    Copy: copy,
    Validate: validate,
    Filter: filter,
    ValidateErrors: validateErrors,
  };
};
